import { render } from "./NewsHorizontal.vue?vue&type=template&id=600f19e3&scoped=true"
import script from "./NewsHorizontal.vue?vue&type=script&lang=js"
export * from "./NewsHorizontal.vue?vue&type=script&lang=js"

import "./NewsHorizontal.vue?vue&type=style&index=0&id=600f19e3&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600f19e3"]])

export default __exports__